export default __webpack_public_path__ + "static/media/mg-vid-1.1af65168.mp4";